export const SET_HOSPITAL_SETTINGS = 'SET_HOSPITAL_SETTINGS';
export const ADD_BURDEN_WEIGHTING = 'ADD_BURDEN_WEIGHTING';
export const DELETE_BURDEN_WEIGHTING = 'DELETE_BURDEN_WEIGHTING';
export const DELETE_WARD_CHECK = 'DELETE_WARD_CHECK';
